
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/pass/coupon",
      function () {
        return require("private-next-pages/m/pass/coupon/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/pass/coupon"])
      });
    }
  